document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.custom-first-atc-btn');
    if (!btn || btn.disabled) return;

    const wrap = btn.closest('.custom-first-atc-wrap');
    const variantId = wrap.dataset.variantId;

    if (!variantId) return;

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });
    } catch (error) {
        console.error('Cart error:', error);
    }
});